"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCreateVariantsInnerToJSON = exports.ProductCreateVariantsInnerFromJSONTyped = exports.ProductCreateVariantsInnerFromJSON = exports.instanceOfProductCreateVariantsInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ProductCreateVariantsInner interface.
 */
function instanceOfProductCreateVariantsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductCreateVariantsInner = instanceOfProductCreateVariantsInner;
function ProductCreateVariantsInnerFromJSON(json) {
    return ProductCreateVariantsInnerFromJSONTyped(json, false);
}
exports.ProductCreateVariantsInnerFromJSON = ProductCreateVariantsInnerFromJSON;
function ProductCreateVariantsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'colorId': !(0, runtime_1.exists)(json, 'color_id') ? undefined : json['color_id'],
    };
}
exports.ProductCreateVariantsInnerFromJSONTyped = ProductCreateVariantsInnerFromJSONTyped;
function ProductCreateVariantsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'color_id': value.colorId,
    };
}
exports.ProductCreateVariantsInnerToJSON = ProductCreateVariantsInnerToJSON;
